module.exports = __webpack_public_path__ + "static/media/IP.85f649cf.webp";